import { Alert, Snackbar } from "@mui/material";
import React, { createContext, useState } from "react";
export const ToastContext = createContext();

const ToastProvider = ({ children }) => {
  const [alert, setAlert] = useState({
    open: false,
    severity: "success",
    message: "asdfsaf",
    timer: 3000,
  });
  const handleClose = () => {
    setAlert((prev) => ({
      ...prev,
      open: false,
    }));
  };
  const showToast = (msg, sev = "success", timer = 3000) => {
    setAlert((prev) => ({
      open: true,
      severity: sev,
      message: msg,
      timer: timer
    }));
  };

  return (
    <ToastContext.Provider value={{showToast}}>
      {children}
      <Snackbar
        open={alert.open}
        autoHideDuration={alert.timer}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleClose}
          severity={alert.severity}
          sx={{ width: "100%" }}
        >
          {alert.message}
        </Alert>
      </Snackbar>
    </ToastContext.Provider>
  );
};

export default ToastProvider;
